import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

// No env vars → "local mode": the app behaves exactly like the Phase 8 single file (data in this browser only).
export const supabase = url && anon ? createClient(url, anon, { auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true } }) : null;
export const isCloud = !!supabase;

// Calls an edge function and turns failures into readable errors.
export async function callFunction(name, body) {
  if (!supabase) throw new Error("This feature needs the hosted app.");
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) {
    let msg = error.message || "Something went wrong.";
    let code;
    try {
      const ctx = error.context;
      if (ctx && typeof ctx.json === "function") {
        const j = await ctx.json();
        if (j && j.error) msg = j.error;
        if (j && j.code) code = j.code;
      }
    } catch (e) { /* keep the generic message */ }
    if (/Failed to send a request|Failed to fetch|NetworkError/i.test(msg)) msg = "Couldn't reach the server. Check your internet connection and try again.";
    const e = new Error(msg);
    if (code) e.code = code;
    throw e;
  }
  return data;
}
